<template>
    <div class="newList">
        <navTop :isLogin="1" title="相君科技新闻资讯"></navTop>
        <div class="list">
            <div class="apcet">
                <div class="news">
                    <div class="for" v-for="(item,index) in newListData.content" :key="index"
                         @click="handlCheckNewsDetal(item)">
                        <div class="img">
                            <img :src="$global.Local + item.pic"/>
                        </div>
                        <div class="right">
                            <div class="title">{{item.title}}</div>
                            <div class="mess">
                                {{item.summary}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination background layout="prev, pager, next" :total="newListData.total"
                                   @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                    <div class="btn">
                        总共：{{newListData.total}}
                    </div>
                </div>
            </div>
        </div>
        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {
                param: {
                    pageNum: 1,
                    pageSize: 10
                },
                newListData: [{
                    title: '多方签约对企业合作尤为关键',
                    message: ` 多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键,
            多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企
            业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键`,
                    url: require('../../../../static/img/banner-1.png')
                },
                    {
                        title: '多方签约对企业合作尤为关键',
                        message: ` 多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键,
            多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企
            业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键`,
                        url: require('../../../../static/img/banner-1.png')
                    },
                    {
                        title: '多方签约对企业合作尤为关键',
                        message: ` 多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键,
            多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企
            业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键`,
                        url: require('../../../../static/img/banner-1.png')
                    },
                    {
                        title: '多方签约对企业合作尤为关键',
                        message: ` 多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键,
            多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企
            业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键`,
                        url: require('../../../../static/img/banner-1.png')
                    },
                    {
                        title: '多方签约对企业合作尤为关键',
                        message: ` 多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键,
            多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企
            业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键
            多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企
            业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键多方签约对企业合作尤为关键`,
                        url: require('../../../../static/img/banner-1.png')
                    },


                ]
            }
        },
        created() {
            this.getData();
        },
        methods: {
            handleCurrentChange(val) {
                this.param.pageNum = val
                this.getData();
            },
            handlCheckNewsDetal(item) {
                this.$router.push({
                    name: 'newsDetal',
                    params: {
                        minId: item.id,
                        bigId: item.newsModuleId
                    }
                });
            },
            getData() {
                let _this = this;
                let formData = new FormData();
                formData.append('pageNum', _this.param.pageNum);
                formData.append('pageSize', _this.param.pageSize);
                _this.api.getNewsList(formData).then(res => {
                    console.log(res);
                    _this.newListData = res;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .newList {
        width: @a;
        height: auto;

        .list {
            width: @a;
            height: auto;
            display: @flex;
            justify-content: center;
            padding: 2% 0;

            .apcet {
                width: 1400px;
                height: auto;

                .news {
                    width: @a;
                    height: auto;

                    .for:hover {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#005bb0,
                        #005bb0);
                        background-blend-mode: normal,
                        normal;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                        color: #fff;
                    }

                    .for:first-child {
                        margin-top: 0;
                    }

                    .for {
                        width: @a;
                        height: 160px;
                        background-color: #ffffff;
                        border: solid 1px #666666;
                        padding: 20px;
                        display: flex;
                        margin-top: 30px;
                        cursor: pointer;
                        color: #333333;

                        .img {
                            width: 120px;
                            height: 120px;

                            img {
                                width: @a;
                                height: @a;
                                object-fit: cover;
                            }
                        }

                        .right {
                            width: calc(@a - 120px);
                            height: auto;
                            margin-left: 57px;

                            .title {
                                width: @a;
                                height: 17px;
                                font-family: MicrosoftYaHei;
                                font-size: 18px;
                                font-weight: bolder;
                                font-stretch: normal;
                                line-height: 30px;
                                letter-spacing: 0px;
                            }

                            .mess {
                                width: @a;
                                height: auto;
                                font-family: MicrosoftYaHei;
                                font-size: 16px;
                                font-weight: normal;
                                font-stretch: normal;
                                line-height: 30px;
                                letter-spacing: 0px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                margin-top: 18px;
                            }
                        }
                    }
                }

                .pagination {
                    @row();
                    margin-top: 30px;

                    .btn {
                        width: 80px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        background-color: #f4f4f5;
                        letter-spacing: 1px;
                        color: #565656;
                        cursor: pointer;
                    }

                    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#005bb0,
                        #005bb0);
                        background-blend-mode: normal,
                        normal;
                    }

                    /deep/ .el-pager li {
                        width: 40px;
                        height: 40px;
                        line-height: 40px;
                    }

                    /deep/ .btn-prev {
                        width: 40px;
                        height: 40px;
                        line-height: 40px;
                    }

                    /deep/ .btn-next {
                        width: 40px;
                        height: 40px;
                        line-height: 40px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/news/newsList.vue